import * as types from '../mutation-types';

const state = {
  // 服务器时间和用户时间差
  timeDiff: null,
  showAccountDetailDialog: false,
  phoneAresCodes: [
    {
      label: '中國大陸',
      code: 86,
    },
    {
      label: '香港',
      code: 852,
    },
    {
      label: '澳門',
      code: 853,
    },
    {
      label: '台灣',
      code: 886,
    },
  ],
  addressTypes: [
    {
      id: 1001,
      label: '香港工商區',
    },
    {
      id: 1002,
      label: '香港非工商區',
    },
  ],
  districts: [
    {
      name: '香港',
      childrens: [
        {
          name: '中西區',
          childrens: [
            {
              name: '上環',
            },
            {
              name: '堅尼地城',
            },
            {
              name: '中環',
            },
            {
              name: '石塘咀',
            },
            {
              name: '西營盤',
            },
            {
              name: '金鐘',
            },
            {
              name: '山頂',
            },
            {
              name: '半山',
            },
            {
              name: '西區',
            },
          ],
        },
        {
          name: '東區',
          childrens: [
            {
              name: '北角',
            },
            {
              name: '則魚涌',
            },
            {
              name: '西灣河',
            },
            {
              name: '筲箕灣',
            },
            {
              name: '柴灣',
            },
            {
              name: '小西灣',
            },
          ],
        },
        {
          name: '南區',
          childrens: [
            {
              name: '香港仔',
            },
            {
              name: '黃竹坑',
            },
            {
              name: '鴨利洲',
            },
            {
              name: '華富',
            },
            {
              name: '薄扶林',
            },
            {
              name: '春磡角',
            },
            {
              name: '淺水灣',
            },
            {
              name: '壽臣山',
            },
            {
              name: '石澳',
            },
            {
              name: '赤柱',
            },
          ],
        },
        {
          name: '灣仔區',
          childrens: [
            {
              name: '灣仔',
            },
            {
              name: '銅鑼灣',
            },
            {
              name: '跑馬地',
            },
            {
              name: '大坑',
            },
            {
              name: '渣甸山',
            },
            {
              name: '掃捍埔',
            },
          ],
        },
      ],
    },
    {
      name: '九龍',
      childrens: [
        {
          name: '觀塘區',
          childrens: [
            {
              name: '九龍灣',
            },
            {
              name: '牛頭角',
            },
            {
              name: '觀塘',
            },
            {
              name: '油塘',
            },
            {
              name: '鯉魚門',
            },
            {
              name: '藍田',
            },
            {
              name: '茶果嶺',
            },
            {
              name: '秀茂坪',
            },
          ],
        },
        {
          name: '油尖旺區',
          childrens: [
            {
              name: '旺角',
            },
            {
              name: '大角咀',
            },
            {
              name: '油麻地',
            },
            {
              name: '佐敦',
            },
            {
              name: '紅磡',
            },
            {
              name: '尖沙咀',
            },
            {
              name: '尖沙咀東',
            },
            {
              name: '京士柏',
            },
          ],
        },
        {
          name: '深水埗區',
          childrens: [
            {
              name: '荔枝角',
            },
            {
              name: '長沙灣',
            },
            {
              name: '深水埗',
            },
            {
              name: '大窩坪',
            },
          ],
        },
        {
          name: '黃大仙區',
          childrens: [
            {
              name: '牛池灣',
            },
            {
              name: '新蒲崗',
            },
            {
              name: '黃大仙',
            },
            {
              name: '鑽石山',
            },
            {
              name: '慈雲山',
            },
            {
              name: '橫頭磡',
            },
            {
              name: '畢架山',
            },
          ],
        },
        {
          name: '九龍城區',
          childrens: [
            {
              name: '九龍城',
            },
            {
              name: '土瓜灣',
            },
            {
              name: '何文田',
            },
            {
              name: '又一村',
            },
          ],
        },
      ],
    },
    {
      name: '新界',
      childrens: [
        {
          name: '北區',
          childrens: [
            {
              name: '粉嶺',
            },
            {
              name: '上水',
            },
          ],
        },
        {
          name: '沙田區',
          childrens: [
            {
              name: '沙田',
            },
            {
              name: '大圍',
            },
            {
              name: '火炭',
            },
            {
              name: '馬鞍山',
            },
            {
              name: '馬料水',
            },
          ],
        },
        {
          name: '大埔',
          childrens: [
            {
              name: '大埔',
            },
            {
              name: '大埔墟',
            },
            {
              name: '太和',
            },
          ],
        },
        {
          name: '屯門區',
          childrens: [
            {
              name: '屯門',
            },
            {
              name: '藍地',
            },
            {
              name: '小欖',
            },
            {
              name: '掃管灘',
            },
            {
              name: '掃管笏',
            },
          ],
        },
        {
          name: '元朗區',
          childrens: [
            {
              name: '元朗',
            },
            {
              name: '洪水橋',
            },
            {
              name: '屏山',
            },
            {
              name: '錦田八鄉',
            },
            {
              name: '天水圍',
            },
            {
              name: '錦繡花園',
            },
            {
              name: '石崗',
            },
            {
              name: '新田',
            },
          ],
        },
        {
          name: '西貢區',
          childrens: [
            {
              name: '西貢',
            },
            {
              name: '清水灣',
            },
            {
              name: '將軍澳',
            },
          ],
        },
        {
          name: '荃灣區',
          childrens: [
            {
              name: '荃灣',
            },
            {
              name: '深井',
            },
            {
              name: '青龍頭',
            },
            {
              name: '大欖涌',
            },
          ],
        },
        {
          name: '葵青區',
          childrens: [
            {
              name: '葵涌',
            },
            {
              name: '葵芳',
            },
            {
              name: '葵盛',
            },
            {
              name: '青衣',
            },
            {
              name: '荔景',
            },
          ],
        },
        {
          name: '離島區',
          childrens: [
            {
              name: '東涌',
            },
            {
              name: '愉景灣',
            },
          ],
        },
      ],
    },
    {
      name: '其他',
    },
  ],
};

const getters = {};

const actions = {
  setTimeDiff({ commit }, val) {
    commit(types.SET_TIMESTAMP_DIFF, val);
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.SET_TIMESTAMP_DIFF](s, val) {
    s.timeDiff = val;
  },
  set_account_detail_dialog(s, val) {
    s.showAccountDetailDialog = val;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js